import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Box, IconButton, Typography, Paper } from '@mui/material';
import FeatherIcon from 'feather-icons-react';

const RMVendorTable = ({
  vendors,
  onEdit,
  onDelete,
}) => {
  const columns = [
    {
      dataField: 'primaryId',
      text: 'ID',
      sort: true,
      headerStyle: { width: '40px' },
    },
    {
      dataField: 'companyName',
      text: 'Company Name',
      sort: true,
      headerStyle: { width: '120px' },
    },
    {
      dataField: 'contactName',
      text: 'Contact Name',
      sort: true,
      headerStyle: { width: '120px' },
    },
    {
      dataField: 'email',
      text: 'Email',
      sort: true,
      headerStyle: { width: '140px' },
    },
    {
      dataField: 'phone',
      text: 'Phone',
      sort: true,
      headerStyle: { width: '140px' },
      formatter: (cell) => `${cell.countryCode} ${cell.number}`,
    },
    {
      dataField: 'address',
      text: 'Address',
      headerStyle: { width: '240px' },
      formatter: (cell) =>
        `${cell.street}, ${cell.city}, ${cell.province}, ${cell.postalCode}, ${cell.country}`,
    },
    {
      dataField: 'isActive',
      text: 'Active',
      sort: true,
      headerStyle: { width: '80px' },
      formatter: (cell) => (cell ? 'Yes' : 'No'),
    },
    {
      dataField: 'actions',
      text: 'Actions',
      headerStyle: { width: '120px' },
      formatter: (cell, row) => (
        <Box display="flex" gap={1}>
          <IconButton onClick={() => onEdit(row)} title="Edit" size="small">
            <FeatherIcon icon="edit" size={20} />
          </IconButton>
          <IconButton onClick={() => onDelete(row)} title="Delete" size="small">
            <FeatherIcon icon="trash-2" size={20} color="red" />
          </IconButton>
        </Box>
      ),
    },
  ];

  const paginationOptions = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const NoDataIndication = () => (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="45vh" width="100%">
      <Box textAlign="center" py={4}>
        <FeatherIcon icon="inbox" size={40} style={{ opacity: 0.5 }} />
        <Typography variant="body2" color="text.secondary" mt={1}>
          There are no vendors to display
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Paper
      sx={{
        minHeight: '75vh',
        maxHeight: '75vh',
        overflow: 'auto',
        borderRadius: 1,
        boxShadow: 1,
        '& thead th': {
          position: 'sticky',
          top: 0,
          backgroundColor: '#f8f9fa',
          zIndex: 2,
          borderBottom: '2px solid #dee2e6',
          padding: '12px 8px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        '& tbody td': {
          padding: '10px 8px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        '& tbody tr:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
        },
        '& .pagination': {
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '16px',
          borderTop: '1px solid #dee2e6',
        },
      }}
      className="miui-table scrollable-table"
    >
      <BootstrapTable
        keyField="_id"
        data={vendors || []}
        columns={columns}
        pagination={paginationFactory(paginationOptions)}
        bootstrap4
        bordered={false}
        hover
        responsive
        noDataIndication={NoDataIndication}
        wrapperClasses="table-responsive"
      />
    </Paper>
  );
};

export { RMVendorTable };
